"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../core/table"));
var _linkButton = _interopRequireDefault(require("../../core/link-button"));
var _sortableRowsContainer = _interopRequireDefault(require("../../core/sortable-rows-container"));
var _reactSortableHoc = require("react-sortable-hoc");
var _addRefCode = _interopRequireDefault(require("./add-ref-code"));
var _refCodeRow = _interopRequireDefault(require("./ref-code-row"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const SortableRefCodeRow = (0, _reactSortableHoc.SortableElement)(_refCodeRow.default);
var _ref = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", null, "Ref Codes"), /*#__PURE__*/_react.default.createElement("p", null, "loading..."));
var _ref2 = /*#__PURE__*/_react.default.createElement("span", {
  className: "pull-xs-right"
}, /*#__PURE__*/_react.default.createElement(_linkButton.default, {
  to: '/settings/ref-codes'
}, "Back to More Codes"));
var _ref3 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref4 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", null, "Code"), /*#__PURE__*/_react.default.createElement("th", null, "Description"), /*#__PURE__*/_react.default.createElement("th", null)));
class RefCode extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onSort", refCodes => {
      this.props.sortRefCodes(refCodes.map(refCode => refCode.id));
    });
  }
  render() {
    if (!this.props.loaded) return _ref;
    const refCodeSets = [{
      setName: 'Current Codes',
      refCodes: this.props.codeType.refCodes.filter(code => !code.isExpired)
    }, {
      setName: 'Expired Codes',
      refCodes: this.props.codeType.refCodes.filter(code => code.isExpired)
    }];
    return /*#__PURE__*/_react.default.createElement("div", null, _ref2, /*#__PURE__*/_react.default.createElement("h2", null, "Ref Codes - ", this.props.codeType.typeName), /*#__PURE__*/_react.default.createElement("p", null, this.props.codeType.description), /*#__PURE__*/_react.default.createElement(_addRefCode.default, {
      codeTypeID: this.props.codeType.id
    }), refCodeSets.map(codeSet => /*#__PURE__*/_react.default.createElement("div", {
      key: codeSet.setName
    }, _ref3, /*#__PURE__*/_react.default.createElement("h5", null, codeSet.setName), !codeSet.refCodes.length ? /*#__PURE__*/_react.default.createElement("p", null, codeSet.setName === 'Expired Codes' ? 'There are no expired ' : 'There are no current ', "ref codes for", ' ', this.props.codeType.typeName) : /*#__PURE__*/_react.default.createElement(_table.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_sortableRowsContainer.default, {
      items: codeSet.refCodes,
      onSort: this._onSort
    }, /*#__PURE__*/_react.default.createElement("tbody", null, codeSet.refCodes.map((refCode, index) => /*#__PURE__*/_react.default.createElement(SortableRefCodeRow, {
      key: refCode.id,
      index: index,
      refCode: refCode
    }))))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref5 = {
  id: true,
  typeName: true,
  description: true,
  refCodes: {
    id: true,
    refCode: true,
    description: true,
    isExpired: true
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(RefCode, props => ({
  ["codeType(id:" + JSON.stringify(props.match.params.codeType) + ")"]: _ref5
}), (client, props) => ({
  sortRefCodes(refCodeIDs) {
    return client.update('CodeType.sort', {
      codeType: props.match.params.codeType,
      refCodeIDs
    });
  }
}), {
  renderLoading: true
});